import React from 'react';
import BgImage from '../../../images/aboutus.png'
import './heroSection.scss'

const HeroSection = () => {
	return (
		<>
			<div className="main-hero-section">
				<section className="hero-section" style={{backgroundImage: `url(${BgImage})`}}>
					<div className="content">
						<h2>Clean UI components. Fast, easy download.</h2>
						<p>Download ready-to-use UI elements for modern web apps. Clean design, developer-friendly code — build faster with SuperCodingBits today.</p>
						{/*<button>Order Now</button>*/}
					</div>
				</section>
			</div>
		</>
	
	);
};

export default HeroSection;